var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fox-button",class:Object.assign({}, _vm.sizeClasses,
    _vm.variantClasses,
    {'fox-button__block': _vm.block}),attrs:{"type":_vm.type,"disabled":_vm.disabled}},[(!_vm.loading)?[(_vm.$slots.icon)?_vm._t("icon"):_vm._e(),_vm._t("default")]:[_c('FoxSpinner')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }